import React from "react";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";

const AutoCompleteInput = ({ inputRef = () => {}, ref, ...other }) => (
  <TextField
    fullWidth
    InputProps={{
      inputRef: node => {
        ref(node);
        inputRef(node);
      },
    }}
    {...other}
  />
);

AutoCompleteInput.propTypes = {
  /**
   * Función que obtiene el texto a mostrar en el autocomplete a partir del elemento.
   **/
  inputRef: PropTypes.func.isRequired,
  /**
   * Query graphql que se utilizará para obtener los elementos
   **/
  ref: PropTypes.object.isRequired,
};

export default AutoCompleteInput;
